// extracted by mini-css-extract-plugin
module.exports = {"selected":"s_selected__34LK6"};